import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { getBundleItemProps } from '../utils/get-bundle-item-props.js';
import { BundleLineItem } from './BundleLineItem.js';

var NonPrescriptionBundleLineItem = (_param)=>{
    var { lineItem  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "lineItem"
    ]);
    const { offering , currency , mainBundleItemPrice  } = lineItem;
    const bundleItem = getBundleItemProps(offering, currency);
    return /*#__PURE__*/ React__default.createElement(BundleLineItem, swcHelpers.extends({}, rest, {
        lineItem: lineItem,
        bundleItems: [
            bundleItem
        ],
        mainBundleItemPrice: mainBundleItemPrice
    }));
};

export { NonPrescriptionBundleLineItem };
//# sourceMappingURL=NonPrescriptionBundleLineItem.js.map
